import cloneDeep from 'lodash/cloneDeep';

import fseTheme from '../../themes/fse/theme';

const fseIntTheme = cloneDeep(fseTheme);
const { header, footer, ...rest } = fseIntTheme;

header.showLogin = false;
header.showLanguageSwitch = false;
footer.showBigFooter = false;

/**
 * @type {Theme}
 */
const fseintTheme = { header, footer, ...rest };

export { fseintTheme };
